<template>
    <div>
        <Modal v-model="modelShow" title="转户协议列表" width="900" @on-visible-change="onVisibleChange">
            <data-grid ref="lg" :columns="cols" :queryParams="queryParams" :queryUrl="queryUrl" paramsName="params" subListName :autoLoad="false">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" highlight-row @on-current-change="onCurrentChange" style="margin:10px"></Table>
                </template>
            </data-grid>
            <div slot="footer">
                <Button type="primary" @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import dataGrid from '@/components/datagrid.vue'
export default {
    props : ['queryParams'],
    components: { dataGrid },
    data() {
        return {
            modelShow: false,
            // queryUrl: "http://CORE-CONTRACT/messageService/queryService/queryFrameTransListByParam",
            queryUrl: "http://CORE-CONTRACT/messageService/queryService/queryValidFrameTransListByParam",
            currentRows: {},
            cols: [
                {title: '转户协议ID', key: 'id' },
                {title: '转户协议名称', key: 'name' },
                {title: '模式', key: 'modeId', dict: ['ENUM_CORE-CONTRACT', 'frameTransEntity.TransMode'] },
                {title: '转户上游', key: 'fromMemberId', dict: ['bizObjects', 'member',true] },
                {title: '转户下游', key: 'toMemberId', dict: ['bizObjects', 'member',true] },
                {title: '标的物小类', key: 'targetType', dict: ['target', 'type',true] },
                {title: '代付租金单价(元/片)', key: 'transUnitRental' },
                {title: '代付服务费单价(元/片)', key: 'transUintService' },
            ],
        }
    },
    methods: {
        openModal() {
            this.modelShow = true
        },
        onVisibleChange(visible){
            if(visible){
                setTimeout(()=>{
                    this.$refs['lg'].loadFirstPage()
                },50)
            }
        },
        onCurrentChange(currentRow) {
            this.currentRows = currentRow
        },
        submit() {
            if (JSON.stringify(this.currentRows)!="{}") {
                this.$emit('onFinish', this.currentRows)
                this.modelShow = false
            }else{
                this.$Message.warning('请选择计费模型ID')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
</style>